export default "__VITE_ASSET__DRO$ASVr__"